import request from '@/utils/request'

// 添加收藏
export function addFavorite(memberId, matchmakerId) {
    return request({
        url: '/api/MatchmakerFavorite/Add',
        method: 'post',
        params: { memberId, matchmakerId }
    })
}

// 取消收藏
export function removeFavorite(memberId, matchmakerId) {
    return request({
        url: '/api/MatchmakerFavorite/Remove',
        method: 'post',
        params: { memberId, matchmakerId }
    })
}

// 获取收藏的红娘ID列表
export function getFavoriteList(memberId) {
    return request({
        url: `/api/MatchmakerFavorite/GetList/${memberId}`,
        method: 'get'
    })
}

// 批量检查是否收藏
export function checkFavorites(memberId, matchmakerIds) {
    return request({
        url: '/api/MatchmakerFavorite/CheckFavorites',
        method: 'post',
        params: { memberId },
        data: matchmakerIds
    })
}

// 检查单条是否收藏
export function isFavorite(memberId, matchmakerId) {
    return request({
        url: '/api/MatchmakerFavorite/IsFavorite',
        method: 'get',
        params: { memberId, matchmakerId }
    })
}


// WEBPACK FOOTER //
// ./src/api/matchmakerFavorite.js